/**
 * Remove an object's top level key and value.
 * @param {Object} object - Object that contains the property key and value to be removed.
 * @param {String} propertyKeyName - Property key name.
 * @returns Object
 */
const removeObjectProperty = (object, propertyKeyName) => {
  let newObject = { ...object };

  if (!propertyKeyName || !newObject?.[propertyKeyName]) {
    return object;
  } else {
    delete newObject[propertyKeyName];
  }

  return newObject;
};

export default removeObjectProperty;
